'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { sdkApi } from '../api.js';

const isMaliciousUrl = (_a) => __awaiter(void 0, [_a], void 0, function* ({ environmentId, url, }) {
    try {
        const request = {
            environmentId,
            scanWebsiteUrlRequest: { url },
        };
        const data = yield sdkApi().scanUrl(request);
        return data.isMalicious;
    }
    catch (error) {
        return undefined;
    }
});

export { isMaliciousUrl };
